import socketClient from '@/services/socket.service.js';
import showToast from '@/util/toast';
import i18n from '@/locales/i18n';

export default function listenChannel(vueInstance, channelName, callback, socketType) {
	socketClient.listenChannel(channelName, (dataString) => {
		const dataObj = JSON.parse(dataString);
		if (dataObj?.socket_type !== socketType) return;
		if (dataObj?.socket_type == "training"){
			if (dataObj?.error) {
				showToast({
					vueInstance: vueInstance,
					type: 'danger',
					message: `<div>Your model <b>${dataObj?.model_name}</b> failed to train by error: </div> <div><i>${dataObj?.error}</i></div> Please try again or contact your administrator`,
				});
				return;
			}
			// Update model list after training complete
			showToast({
				vueInstance: vueInstance,
				type: 'success',
				message: `<div>Your model <b>${dataObj?.model_name}</b> has been trained!</div> Please go to detector to try it out`,
			});
		}
		callback({username: channelName});
	});
}
